import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Typography,
  TextField,
  Box,
  Chip,
  Grid,
  Card,
  CardContent,
  Divider,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  TablePagination,
  Switch,
  FormGroup
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import base from '../../config';
import { headers } from "../../helper/api";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { tokenValidation } from "../../helper/customizedHooks";
import { processL2Approval, processStandardApproval, processRequestClarification, resetL2ApprovalState } from "../../redux/fui/index";
import AcknowledgementService from '../../services/acknowledgementService';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import SecurityIcon from '@material-ui/icons/Security';
import CloudIcon from '@material-ui/icons/Cloud';
import HelpIcon from '@material-ui/icons/Help';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { ToastContainer, toast } from 'react-toastify';
import { Footer } from "../common/Footer";
import Navbar from "../common/CommonNavbar/CommonNavbar";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '8px 24px 120px 24px',         // Fixed padding with extra bottom space
    backgroundColor: '#f8f9fa',
    minHeight: 'calc(100vh - 70px)',        // Reduced height to account for banner
    marginTop: '0px',                       // No top margin (header now relative)
    marginBottom: '0px',                    // No bottom margin
  },
  pageDescription: {
    fontSize: '1.1rem',
    color: '#495057',
    marginBottom: theme.spacing(3),
    fontWeight: 500,
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    color: 'white',
    padding: theme.spacing(2, 3),
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(117, 0, 192, 0.2)',
    border: 'none',
  },
  fixedHeader: {
    position: 'relative',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e9ecef',
  },
  fixedFooter: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e9ecef',
  },
  header: {
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    borderRadius: '8px',
    padding: theme.spacing(4),
    marginBottom: theme.spacing(3),
    color: 'white',
    boxShadow: '0 10px 30px rgba(117, 0, 192, 0.2)',
  },
  pageTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '1.1rem',
    opacity: 0.9,
    fontWeight: 300,
  },
  statsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    width: '100%',
    '& > *': {
      flex: '1 1 250px',
      minWidth: '250px',
    }
  },
  statCard: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '6px',
    padding: theme.spacing(3),
    boxShadow: '0 4px 16px rgba(117, 0, 192, 0.08)',
    border: '1px solid #e9ecef',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    margin: theme.spacing(1),
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(117, 0, 192, 0.15)',
      border: '1px solid #7500C0',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: '#7500C0',
    }
  },
  statNumber: {
    fontSize: '3.5rem',
    fontWeight: 800,
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: 1,
    marginBottom: theme.spacing(1),
  },
  statLabel: {
    fontSize: '0.95rem',
    color: '#4a5568',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: theme.spacing(0.5),
  },
  statSubtext: {
    fontSize: '0.75rem',
    color: '#718096',
    fontWeight: 400,
    fontStyle: 'italic',
  },
  statIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    fontSize: '2rem',
    opacity: 0.1,
    color: '#7500C0',
  },
  tableContainer: {
    background: 'white',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #e9ecef',
    overflow: 'hidden',
  },
  tableHead: {
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    '& .MuiTableCell-head': {
      color: 'white',
      fontWeight: 600,
      fontSize: '0.875rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      padding: theme.spacing(2),
      borderBottom: 'none',
    }
  },
  tableRow: {
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      transform: 'scale(1.001)',
    },
    '& .MuiTableCell-body': {
      padding: theme.spacing(2),
      borderBottom: '1px solid #e9ecef',
      fontSize: '0.875rem',
    }
  },
  levelBadge: {
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: 600,
    display: 'inline-block',
    minWidth: '100px',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    '&.level1': {
      backgroundColor: '#e8f5e8',
      color: '#2e7d32',
      border: '1px solid #4caf50',
    },
    '&.level2': {
      backgroundColor: '#fff3e0',
      color: '#f57c00',
      border: '1px solid #ffb74d',
    }
  },
  priorityChip: {
    fontWeight: 600,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    }
  },
  statusChip: {
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: '#fff3cd',
    color: '#856404',
    border: '1px solid #ffeaa7',
  },
  actionButton: {
    borderRadius: '4px',
    padding: '6px 16px',
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    }
  },
  reviewButton: {
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    color: 'white',
  },
  approveButton: {
    background: 'linear-gradient(135deg, #48bb78, #38a169)',
    color: 'white',
  },
  rejectButton: {
    background: 'linear-gradient(135deg, #f56565, #e53e3e)',
    color: 'white',
  },
  clarificationButton: {
    background: 'linear-gradient(135deg, #f39c12, #e67e22)',
    color: 'white',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  loadingText: {
    color: '#718096',
    fontSize: '1.1rem',
    fontWeight: 500,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(8),
    '& .MuiTypography-root': {
      color: '#718096',
    }
  },
  refreshButton: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    color: 'white',
    width: 60,
    height: 60,
    borderRadius: '50%',
    boxShadow: '0 8px 25px rgba(117, 0, 192, 0.3)',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0 12px 35px rgba(117, 0, 192, 0.4)',
    }
  },
  // Dialog Styles
  dialogPaper: {
    borderRadius: '8px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    overflow: 'hidden',
    maxWidth: '900px',
    width: '90vw',
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    color: 'white',
    padding: theme.spacing(3, 4),
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #ffffff20, #ffffff40, #ffffff20)',
    }
  },
  dialogTitleText: {
    fontSize: '1.25rem',
    fontWeight: 600,
    letterSpacing: 'normal',
  },
  dialogContent: {
    padding: theme.spacing(2, 3),
    backgroundColor: '#fafbfc',
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #e9ecef',
    gap: theme.spacing(1),
  },
  summaryCard: {
    background: '#f8f9fa',
    borderRadius: '6px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: '1px solid #7500C0',
    borderLeftWidth: '4px',
  },
  detailCard: {
    background: 'white',
    borderRadius: '6px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
    border: '1px solid #e9ecef',
  },
  sectionTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#7500C0',
    marginBottom: theme.spacing(1.5),
  },
  fieldLabel: {
    fontSize: '0.75rem',
    fontWeight: 700,
    color: '#495057',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    marginBottom: theme.spacing(0.25),
  },
  fieldValue: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: '#495057',
    marginBottom: theme.spacing(1.5),
    wordBreak: 'break-word',
  },
  justificationCard: {
    background: '#f7fafc',
    borderRadius: '6px',
    padding: theme.spacing(2),
    border: '1px solid #7500C0',
    borderLeftWidth: '4px',
    marginBottom: theme.spacing(2),
  },
  justificationText: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#2d3748',
    fontStyle: 'italic',
  },
  commentField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: 'white',
      '& fieldset': {
        borderColor: '#e9ecef',
      },
      '&:hover fieldset': {
        borderColor: '#7500C0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#7500C0',
      }
    },
    '& .MuiInputLabel-root': {
      color: '#4a5568',
      fontWeight: 500,
    }
  },
  dialogButton: {
    borderRadius: '4px',
    padding: '8px 20px',
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    minWidth: '100px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    }
  },
  cancelButton: {
    backgroundColor: '#e2e8f0',
    color: '#4a5568',
    border: '2px solid #cbd5e0',
    '&:hover': {
      backgroundColor: '#cbd5e0',
      borderColor: '#a0aec0',
    }
  },

  // Filter styles
  filtersContainer: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    border: '1px solid #e0e0e0',
  },
  filtersHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '16px',
    color: '#7500C0',
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },
  filtersRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '& > *': {
      flex: '1 1 auto',
      minWidth: '140px',
    },
  },
  filterControl: {
    flex: '1 1 auto',
    minWidth: '140px',
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#7500C0',
      },
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#7500C0',
    },
  },
  searchField: {
    flex: '2 1 auto',
    minWidth: '200px',
  },
  clearFiltersBtn: {
    color: '#666',
    borderColor: '#ddd',
    flex: '0 0 auto',
    minWidth: '100px',
    height: '40px',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#7500C0',
    },
  }
}));

const Approvals = ({
  email,
  isAuthenticated,
  history,
  processL2Approval,
  processStandardApproval,
  processRequestClarification,
  resetL2ApprovalState,
  isL2ApprovalLoading,
  isL2ApprovalSuccess,
  hideNavbar,
  activeTab,
  handleTabChange,
  tabsComponent,
  dedicatedVpcComponent,
  isFormSubmittedSuccessful,
  l2ApprovalError,
  onAppPlatformCountChange,
  isAdminView
}) => {
  const classes = useStyles();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [comments, setComments] = useState('');
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState('');
  const [confirmComments, setConfirmComments] = useState('');
  const [acknowledgementChecked, setAcknowledgementChecked] = useState(false);
  const [acknowledgementData, setAcknowledgementData] = useState(null);
  const [acknowledgementLoading, setAcknowledgementLoading] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState(null);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [clarificationDialog, setClarificationDialog] = useState(false);
  const [clarificationComments, setClarificationComments] = useState('');
  const [level2Required, setLevel2Required] = useState(false);
  const [dateSortOrder, setDateSortOrder] = useState('desc'); // 'asc' for old to latest, 'desc' for latest to old

  // Search state (like OrderRequestsList.js)
  const [searchQuery, setSearchQuery] = useState("");

  // Filter states
  const [filters, setFilters] = useState({
    journey: 'all', // all, client, internal
    approvalLevel: 'all', // all, level1, level2
    environment: 'all', // all, production, dev, test
    status: 'all', // all, pending, clarification_requested
    dateRange: 'all' // all, today, week, month
  });

  useEffect(() => {
    tokenValidation();

    // Try multiple ways to get the email
    const userEmail = email && email.email ? email.email
      : email && email.username ? email.username
        : localStorage.getItem('userEmail');

    if (userEmail) {
      // Reset pagination when admin view changes
      setPage(0);
      fetchApprovalTasks();

      // Auto-refresh every 10 seconds (without loading indicator)
      const interval = setInterval(() => {
        fetchApprovalTasks(false);
      }, 10000);

      return () => clearInterval(interval);
    } else {
      setLoading(false);
    }
  }, [email, isAuthenticated, isAdminView]); // Added isAdminView dependency

  // Handle Redux state changes for approvals
  useEffect(() => {
    if (isL2ApprovalSuccess || isFormSubmittedSuccessful) {
      toast.success('Request processed successfully');
      // Close dialogs on success
      setDetailsDialog(false);
      setConfirmDialog(false);
      setClarificationDialog(false);
      setAcknowledgementChecked(false); // Reset acknowledgement
      setAcknowledgementData(null);
      setAcknowledgementError(null);
      setLevel2Required(false); // Reset SecOps review decision to default
      fetchApprovalTasks(false); // Refresh the list without loading indicator

      // Reset the success state after handling
      setTimeout(() => {
        resetL2ApprovalState();
      }, 100); // Small delay to ensure toast shows
    }
  }, [isL2ApprovalSuccess, isFormSubmittedSuccessful]);

  // Update count for App/Platform orders
  useEffect(() => {
    if (onAppPlatformCountChange && tasks) {
      onAppPlatformCountChange(tasks.length);
    }
  }, [tasks, onAppPlatformCountChange]);

  useEffect(() => {
    if (l2ApprovalError) {
      toast.error('Failed to process request');
      // console.error('L2 Approval Error:', l2ApprovalError);
      // Close dialogs on error too
      setDetailsDialog(false);
      setConfirmDialog(false);
      setClarificationDialog(false);
      setLevel2Required(false); // Reset SecOps review decision to default
    }
  }, [l2ApprovalError]);

  // Filter functions
  // Search handler (exactly like OrderRequestsList.js)
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to first page when searching
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    // Reset to first page when any filter changes
    setPage(0);
  };

  const clearFilters = () => {
    setSearchQuery("");
    setFilters({
      journey: 'all',
      approvalLevel: 'all',
      environment: 'all',
      status: 'all',
      dateRange: 'all'
    });
    // Reset to first page when clearing filters
    setPage(0);
  };

  const handleDateSort = () => {
    const newSortOrder = dateSortOrder === 'desc' ? 'asc' : 'desc';
    setDateSortOrder(newSortOrder);
  };

  // All filtered tasks (before pagination) - exactly like OrderRequestsList.js
  const allFilteredTasks = React.useMemo(() => {
    const baseFilteredTasks = tasks.filter(task => {
      // Search filter - exactly like OrderRequestsList.js
      if (searchQuery && searchQuery.trim()) {
        const searchLower = searchQuery.toLowerCase().trim();
        const requestId = task.request_id ? task.request_id.toLowerCase().trim() : '';
        const requester = task.requester ? task.requester.toLowerCase() : '';
        const combinationKey = task.combination_key ? task.combination_key.toLowerCase() : '';
        const approvalLevel = task.approval_level ? task.approval_level.toLowerCase() : '';
        const journey = task.journey ? task.journey.toLowerCase() : '';
        const environment = task.environment ? task.environment.toLowerCase() : '';

        const approver = task.approver ? task.approver.toLowerCase() : '';

        const matchesSearch = requestId.includes(searchLower) ||
          requester.includes(searchLower) ||
          combinationKey.includes(searchLower) ||
          approvalLevel.includes(searchLower) ||
          journey.includes(searchLower) ||
          environment.includes(searchLower) ||
          (isAdminView && approver.includes(searchLower));


        if (!matchesSearch) return false;
      }

      // Journey filter
      if (filters.journey !== 'all') {
        if (filters.journey === 'client' && (!task.journey || task.journey.toLowerCase() !== 'client')) return false;
        if (filters.journey === 'internal' && task.journey && task.journey.toLowerCase() === 'client') return false;
      }

      // Approval Level filter
      if (filters.approvalLevel !== 'all') {
        if (filters.approvalLevel === 'level1' && task.approval_level !== 'Level 1 Approval') return false;
        if (filters.approvalLevel === 'level2' && task.approval_level !== 'Level 2 Approval') return false;
      }

      // Environment filter
      if (filters.environment !== 'all') {
        const taskEnv = task.environment && task.environment.toLowerCase();
        if (filters.environment === 'production' && taskEnv !== 'prod' && taskEnv !== 'production') return false;
        if (filters.environment === 'dev' && taskEnv !== 'dev') return false;
        if (filters.environment === 'test' && taskEnv !== 'test') return false;
      }

      // Status filter
      if (filters.status !== 'all') {
        if (filters.status === 'pending' && task.status !== 'PENDING') return false;
        if (filters.status === 'clarification_requested' && task.status !== 'CLARIFICATION_REQUESTED') return false;
      }

      // Date range filter
      if (filters.dateRange !== 'all' && task.created_at) {
        const taskDate = new Date(task.created_at);
        const now = new Date();
        const diffTime = Math.abs(now - taskDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (filters.dateRange === 'today' && diffDays > 1) return false;
        if (filters.dateRange === 'week' && diffDays > 7) return false;
        if (filters.dateRange === 'month' && diffDays > 30) return false;
      }

      return true;
    });

    // Sort tasks by date with improved handling
    const sortedTasks = [...baseFilteredTasks].sort((a, b) => {
      // Helper function to safely parse dates
      const parseDate = (task) => {
        const dateValue = task.submitted_on || task.created_at;
        if (!dateValue) return new Date(0); // Use epoch as fallback for null dates

        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? new Date(0) : date;
      };

      const dateA = parseDate(a);
      const dateB = parseDate(b);

      if (dateSortOrder === 'desc') {
        return dateB.getTime() - dateA.getTime(); // Latest to old
      } else {
        return dateA.getTime() - dateB.getTime(); // Old to latest
      }
    });

    return sortedTasks;
  }, [tasks, searchQuery, filters, dateSortOrder]);


  // Get paginated filtered tasks
  const filteredTasks = React.useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return allFilteredTasks.slice(startIndex, endIndex);
  }, [allFilteredTasks, page, rowsPerPage]);

  const fetchApprovalTasks = async (showLoading = true) => {
    try {
      const token = localStorage.getItem('token');
      // Get user email from multiple sources
      const userEmail = email && email.email ? email.email
        : email && email.username ? email.username
          : localStorage.getItem('userEmail');

      if (!userEmail) {
        setLoading(false);
        return;
      }

      // Fetch approval tasks from DynamoDB
      const url = `${base.urls.apis.order}/approvals/my-tasks`;

      // Add admin override parameter if toggle is enabled
      const params = isAdminView ? { admin_override: 'true' } : {};

      const response = await axios.get(url, {
        headers: { ...headers, Authorization: token },
        params: params
      });


      // Expect approval tasks from your backend function
      const tasks = response.data.tasks ? response.data.tasks : response.data;

      setTasks(tasks);
    } catch (error) {
      // console.error('Error fetching approval tasks:', error);

      // Show user-friendly error message
      if (error.response && error.response.status === 500) {
        toast.error('Server error: Please check if the /approvals/my-tasks endpoint is implemented');
      } else {
        toast.error('Failed to load approval tasks');
      }

      setTasks([]);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  // Fetch acknowledgement message based on order type
  const fetchAcknowledgementMessage = async (orderType) => {
    try {
      setAcknowledgementLoading(true);
      setAcknowledgementError(null);
      const result = await AcknowledgementService.getAcknowledgementMessage(orderType, 'approver');
      if (result.success) {
        setAcknowledgementData(result.data);
      } else {
        setAcknowledgementError(result.error);
      }
    } catch (error) {
      setAcknowledgementError('Failed to load acknowledgement message');
    } finally {
      setAcknowledgementLoading(false);
    }
  };

  // Format acknowledgement text for better display
  const formatAcknowledgementText = (text) => {
    if (!text) return '';

    // Split by lines and process each line
    return text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .map((line, index) => {
        // Check if line starts with number pattern (1., 2., etc.)
        const numberMatch = line.match(/^(\d+\.?\s*)(.*)/);
        if (numberMatch) {
          const [, number, content] = numberMatch;
          return (
            <div key={index} style={{
              display: 'flex',
              marginBottom: '6px',
              alignItems: 'baseline',
              paddingLeft: '12px',
              lineHeight: '1.5'
            }}>
              <span style={{
                minWidth: '20px',
                fontWeight: '500',
                color: '#6b7280',
                marginRight: '2px',
                lineHeight: '1.5'
              }}>
                {number}
              </span>
              <span style={{
                flex: 1,
                lineHeight: '1.5'
              }}>
                {content}
              </span>
            </div>
          );
        }
        // Regular line without numbering
        return (
          <div key={index} style={{ marginBottom: '6px', paddingLeft: '12px' }}>
            {line}
          </div>
        );
      });
  };

  // Pagination functions

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page when changing page size
  };

  const handleReviewClick = async (requestId) => {
    setSelectedRequest(requestId);
    setDetailsDialog(true);
    setDetailsLoading(true);
    setComments('');

    try {
      const token = localStorage.getItem('token');


      // For now, since we're using mock data, let's create a mock order detail
      // TODO: Replace with actual API call when backend is ready

      // Use a dedicated endpoint for fetching single order details
      // This should be implemented in your backend to fetch by request_id efficiently

      let orderData = null;

      try {
        // Use the implemented approvals details endpoint with query string
        const response = await axios.get(
          `${base.urls.apis.order}/approvals/details?request_id=${requestId}`,
          { headers: { ...headers, Authorization: token } }
        );

        // Handle array response - take the first order
        if (Array.isArray(response.data)) {
          orderData = response.data[0];
        } else {
          orderData = response.data;
        }

      } catch (error) {
        toast.error('Failed to fetch order details');
      }

      if (!orderData) {
        setOrderDetails(null);
        return;
      }

      setOrderDetails(orderData);

    } catch (error) {
      console.error('Error fetching order details:', error);
      toast.error('Failed to load request details');
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleApproveClick = () => {
    setConfirmAction('approve');
    setConfirmComments('');
    setConfirmDialog(true);

    // Determine order type and fetch acknowledgement message
    const currentTask = tasks.find(task => task.request_id === selectedRequest);
    const orderType = currentTask && currentTask.journey && currentTask.journey.toLowerCase() === 'client' ? 'client' : 'internal';

    fetchAcknowledgementMessage(orderType);
  };

  const handleRejectClick = () => {
    setConfirmAction('reject');
    setConfirmComments('');
    setConfirmDialog(true);
  };

  const handleClarificationClick = () => {
    setClarificationComments('');
    setClarificationDialog(true);
  };

  const handleConfirmAction = () => {
    if (!confirmComments.trim()) {
      toast.error(`Please provide comments for ${confirmAction}`);
      return;
    }

    // Check acknowledgement for approvals
    if (confirmAction === 'approve' && !acknowledgementChecked) {
      toast.error('Please acknowledge the approver responsibilities before proceeding');
      return;
    }

    // Add admin override information to comments if applicable
    let finalComments = confirmComments;
    if (isAdminView) {
      const userEmail = email && email.email ? email.email
        : email && email.username ? email.username
          : localStorage.getItem('userEmail');
      finalComments = `${confirmComments}`;
    }

    // Find the current task to determine approval level
    const currentTask = tasks.find(task => task.request_id === selectedRequest);
    const isL2Approval = currentTask && currentTask.approval_level === 'Level 2 Approval';

    // Prepare acknowledgement data for approval submission
    const acknowledgementPayload = acknowledgementData ? {
      acknowledgement_id: acknowledgementData.acknowledgementId,
      acknowledgement_version: acknowledgementData.version
    } : null;

    if (confirmAction === 'approve' && isL2Approval) {
      // L2 Approval: Always use processL2Approval (hits provisioning + approval/approve)
      processL2Approval(selectedRequest, finalComments, orderDetails, acknowledgementPayload);
    } else if (confirmAction === 'approve') {
      // L1 Approval: Pass the SecOps review decision from the approver to the backend
      // Backend will use this decision instead of the hardcoded LEVEL2_ENABLED setting
      processStandardApproval(selectedRequest, finalComments, confirmAction, orderDetails, level2Required, acknowledgementPayload);
    } else {
      // Rejection: Always use standard approval (no provisioning)
      processStandardApproval(selectedRequest, finalComments, confirmAction, orderDetails, null, acknowledgementPayload);
    }

    // Don't close dialogs here - let Redux state handle it
    // Dialogs will close in useEffect when success/error occurs
  };

  const handleCancelConfirm = () => {
    setConfirmDialog(false);
    setConfirmComments('');
    setConfirmAction('');
    setAcknowledgementChecked(false);
    setAcknowledgementData(null);
    setAcknowledgementError(null);
    setLevel2Required(false); // Reset to default (unchecked)
  };

  const handleConfirmClarification = () => {
    if (!clarificationComments.trim()) {
      toast.error('Please provide clarification details');
      return;
    }

    // Add admin override information to clarification comments if applicable
    let finalClarificationComments = clarificationComments;
    if (isAdminView) {
      const userEmail = email && email.email ? email.email
        : email && email.username ? email.username
          : localStorage.getItem('userEmail');
      finalClarificationComments = `${clarificationComments}`;
    }

    processRequestClarification(selectedRequest, finalClarificationComments);

    // Don't close dialog here - let Redux state handle it
    // Dialog will close in useEffect when success/error occurs
  };

  const handleCancelClarification = () => {
    setClarificationDialog(false);
    setClarificationComments('');
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return 'N/A';
    }

    try {
      // If already formatted (like '27-May-2026'), return as is
      if (typeof dateString === 'string' && /^\d{1,2}-\w{3}-\d{4}$/.test(dateString)) {
        return dateString;
      }

      // Handle ISO timestamp format like "2026-06-01T05:50:43.525264"
      const date = new Date(dateString);
      if (!isNaN(date.getTime()) && date.getTime() > 0) {
        const dateStr = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });

        const timeStr = date.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZoneName: 'short'
        });

        // Format: "01 Jun 2026, 05:50 IST"
        return `${dateStr}, ${timeStr}`;
      }

      // If it's a string that couldn't be parsed, return as is
      return dateString || 'N/A';
    } catch (error) {
      return dateString || 'N/A';
    }
  };

  const getConfigValue = (config, key) => {
    try {
      if (!config || !Array.isArray(config)) {
        return 'N/A';
      }

      const item = config.find(c => c && c.Key === key);
      return item && item.Value !== undefined && item.Value !== null ? item.Value : 'N/A';
    } catch (error) {
      return 'N/A';
    }
  };

  const getRequestorName = (task) => {
    try {
      if (!task) return 'N/A';
      // Try different possible field names for requestor
      return task.requestor || task.requester || task.created_by || task.CreatedBy || task.submittedBy || 'N/A';
    } catch (error) {
      return 'N/A';
    }
  };

  const safeGetValue = (obj, path, defaultValue = 'N/A') => {
    try {
      const keys = path.split('.');
      let result = obj;
      for (const key of keys) {
        if (result === null || result === undefined) return defaultValue;
        result = result[key];
      }
      return result !== undefined && result !== null ? result : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  };

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.loadingContainer}>
          <CircularProgress size={60} style={{ color: '#7500C0' }} />
          <Typography className={classes.loadingText}>
            Loading approval requests...
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={classes.fixedHeader}>
        <Navbar screenName="Approval Dashboard" />
      </div>
      <div className={classes.root}>

        {/* Tabs Section - Show at the top */}
        {tabsComponent && tabsComponent}


        {/* Statistics Cards - Only for App/Platform Orders tab */}
        {(!activeTab || activeTab === 0) && (
          <div className={classes.statsContainer}>
            <div className={classes.statCard}>
              <AssignmentIcon className={classes.statIcon} />
              <Typography className={classes.statLabel}>
                Total Requests
              </Typography>
              <Typography className={classes.statNumber}>
                {tasks.length}
              </Typography>
              <Typography className={classes.statSubtext}>
                {isAdminView ? 'System-wide approvals' : 'Awaiting your approval'}
              </Typography>
            </div>
            <div className={classes.statCard}>
              <CloudIcon className={classes.statIcon} />
              <Typography className={classes.statLabel}>
                Client Requests
              </Typography>
              <Typography className={classes.statNumber}>
                {tasks.filter(task => {
                  // Check if it's a client request (journey = "client")
                  return task.journey && task.journey.toLowerCase() === 'client';
                }).length}
              </Typography>
              <Typography className={classes.statSubtext}>
                Client journey requests
              </Typography>
            </div>
            <div className={classes.statCard}>
              <SecurityIcon className={classes.statIcon} />
              <Typography className={classes.statLabel}>
                Internal Requests
              </Typography>
              <Typography className={classes.statNumber}>
                {tasks.filter(task => {
                  // Check if it's an internal request (journey != "client")
                  return !task.journey || task.journey.toLowerCase() !== 'client';
                }).length}
              </Typography>
              <Typography className={classes.statSubtext}>
                Non-client journey requests
              </Typography>
            </div>
            <div className={classes.statCard}>
              <PriorityHighIcon className={classes.statIcon} />
              <Typography className={classes.statLabel}>
                Today's Requests
              </Typography>
              <Typography className={classes.statNumber}>
                {tasks.filter(task => {
                  if (!task.submitted_on && !task.created_at) return false;
                  const submittedDate = new Date(task.submitted_on || task.created_at);
                  const today = new Date();
                  return submittedDate.toDateString() === today.toDateString();
                }).length}
              </Typography>
              <Typography className={classes.statSubtext}>
                Submitted today
              </Typography>
            </div>
          </div>
        )}

        {/* Filters Section - Only for App/Platform Orders tab */}
        {(!activeTab || activeTab === 0) && (
          <div className={classes.filtersContainer}>
            <div className={classes.filtersHeader}>
              <Typography component="span" style={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
                Filter Requests
              </Typography>
              <Typography variant="body2" style={{ color: '#666', fontWeight: 500, marginLeft: 'auto' }}>
                {filteredTasks.length} of {tasks.length} requests
              </Typography>
            </div>

            <div className={classes.filtersRow}>
              {/* Search Filter */}
              <TextField
                className={`${classes.filterControl} ${classes.searchField}`}
                label="Search"
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder={isAdminView
                  ? "Search by Request ID, Requester, Approver, or Platform..."
                  : "Search by Request ID, Requester, or Platform..."}
              />

              {/* Journey Filter */}
              <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel>Journey Type</InputLabel>
                <Select
                  value={filters.journey}
                  onChange={(e) => handleFilterChange('journey', e.target.value)}
                  label="Journey Type"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        minWidth: 180
                      }
                    }
                  }}
                >
                  <MenuItem value="all">All Journeys</MenuItem>
                  <MenuItem value="client">Client Journey</MenuItem>
                  <MenuItem value="internal">Internal Journey</MenuItem>
                </Select>
              </FormControl>

              {/* Approval Level Filter */}
              {/* <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel>Approval Level</InputLabel>
                <Select
                  value={filters.approvalLevel}
                  onChange={(e) => handleFilterChange('approvalLevel', e.target.value)}
                  label="Approval Level"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        minWidth: 180
                      }
                    }
                  }}
                >
                  <MenuItem value="all">All Levels</MenuItem>
                  <MenuItem value="level1">Level 1</MenuItem>
                  <MenuItem value="level2">Level 2</MenuItem>
                </Select>
              </FormControl> */}

              {/* Environment Filter */}
              <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel>Environment</InputLabel>
                <Select
                  value={filters.environment}
                  onChange={(e) => handleFilterChange('environment', e.target.value)}
                  label="Environment"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        minWidth: 180
                      }
                    }
                  }}
                >
                  <MenuItem value="all">All Environments</MenuItem>
                  <MenuItem value="production">Production</MenuItem>
                  <MenuItem value="dev">Development</MenuItem>
                  <MenuItem value="test">Test</MenuItem>
                </Select>
              </FormControl>

              {/* Status Filter */}
              {/* <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                  label="Status"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        minWidth: 200
                      }
                    }
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="clarification_requested">Clarification Requested</MenuItem>
                </Select>
              </FormControl> */}

              {/* Date Range Filter */}
              <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel>Date Range</InputLabel>
                <Select
                  value={filters.dateRange}
                  onChange={(e) => handleFilterChange('dateRange', e.target.value)}
                  label="Date Range"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        minWidth: 180
                      }
                    }
                  }}
                >
                  <MenuItem value="all">All Time</MenuItem>
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="week">This Week</MenuItem>
                  <MenuItem value="month">This Month</MenuItem>
                </Select>
              </FormControl>

              {/* Clear Filters Button */}
              <Button
                variant="outlined"
                size="small"
                onClick={clearFilters}
                className={classes.clearFiltersBtn}
              >
                Clear Filters
              </Button>
            </div>
          </div>
        )}

        {/* Enhanced Table */}
        {(!activeTab || activeTab === 0) && (
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell>Request ID</TableCell>
                  {/* <TableCell>Level</TableCell> */}
                  <TableCell>Requestor</TableCell>
                  {isAdminView && <TableCell>Assigned Approver</TableCell>}
                  <TableCell>Journey</TableCell>
                  <TableCell>Environment</TableCell>
                  <TableCell>
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{ cursor: 'pointer' }}
                      onClick={handleDateSort}
                      title={`Sort by date ${dateSortOrder === 'desc' ? 'ascending' : 'descending'}`}
                    >
                      <span>Submitted</span>
                      <IconButton
                        size="small"
                        style={{
                          marginLeft: '8px',
                          padding: '4px',
                          backgroundColor: '#7500C0',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          '&:hover': {
                            backgroundColor: '#5a0090'
                          }
                        }}
                        aria-label={`Sort by date ${dateSortOrder === 'desc' ? 'ascending' : 'descending'}`}
                      >
                        {dateSortOrder === 'desc' ? (
                          <ArrowDownwardIcon style={{ fontSize: '14px', color: '#ffffff' }} />
                        ) : (
                          <ArrowUpwardIcon style={{ fontSize: '14px', color: '#ffffff' }} />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTasks.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={isAdminView ? 9 : 8} className={classes.emptyState}>
                      <Typography variant="h6" gutterBottom>
                        {tasks.length === 0 ? 'No Pending Approvals' : 'No Results Found'}
                      </Typography>
                      <Typography variant="body2">
                        {tasks.length === 0
                          ? 'All caught up! No approval requests require your attention at this time.'
                          : 'No approval requests match your current filter criteria. Try adjusting the filters above.'
                        }
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {filteredTasks.map((task, index) => (
                      <TableRow key={`${task.request_id}-${index}`} className={classes.tableRow}>
                        <TableCell>
                          <Typography variant="body2" style={{ fontFamily: 'Monaco, monospace', fontWeight: 600, color: '#4a5568' }}>
                            {task.request_id}
                          </Typography>
                        </TableCell>
                        {/* <TableCell>
                          <span className={`${classes.levelBadge} ${task.level === 1 ? 'level1' : 'level2'}`}>
                            {task.approval_level}
                          </span>
                        </TableCell> */}
                        <TableCell>
                          <Typography variant="body2" style={{ fontWeight: 500, color: '#2d3748' }}>
                            {getRequestorName(task)}
                          </Typography>
                        </TableCell>
                        {isAdminView && (
                          <TableCell>
                            <Typography variant="body2" style={{
                              fontWeight: 500,
                              color: '#e53e3e',
                              fontSize: '0.875rem'
                            }}>
                              {task.approver ? task.approver.split('@')[0] : 'Not Assigned'}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell>
                          <Chip
                            label={task.journey}
                            className={classes.priorityChip}
                            size="small"
                            variant="outlined"
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={task.environment}
                            className={classes.priorityChip}
                            size="small"
                            variant="outlined"
                            color={task.environment === 'Prod' ? 'secondary' : 'default'}
                            style={{
                              backgroundColor: task.environment === 'Prod' ? '#fed7d7' : '#e2e8f0',
                              color: task.environment === 'Prod' ? '#c53030' : '#4a5568',
                              border: task.environment === 'Prod' ? '1px solid #fc8181' : '1px solid #cbd5e0'
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" style={{ color: '#4a5568' }}>
                            {formatDate(task.submitted_on || task.created_at)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <span className={classes.statusChip}>
                            {task.status}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            size="small"
                            className={`${classes.actionButton} ${classes.reviewButton}`}
                            onClick={() => handleReviewClick(task.request_id)}
                            startIcon={<VisibilityIcon />}
                          >
                            Review
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Pagination Controls - only show for App/Platform tab when there are tasks */}
        {activeTab === 0 && allFilteredTasks.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={allFilteredTasks.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            style={{ borderTop: "1px solid #e0e0e0" }}
          />
        )}

        {/* Dedicated VPC Tab Content */}
        {activeTab === 1 && dedicatedVpcComponent && dedicatedVpcComponent}

        {/* Order Details Dialog */}
        <Dialog
          open={detailsDialog}
          onClose={() => setDetailsDialog(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            className: classes.dialogPaper
          }}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
              <Typography className={classes.dialogTitleText}>
                Request Details - {selectedRequest}
              </Typography>

              {/* Approval Status Chips */}
              {(() => {
                const currentTask = tasks.find(task => task.request_id === selectedRequest);
                if (!currentTask) return null;

                const isLevel1 = currentTask.approval_level === 'Level 1 Approval';
                const isLevel2 = currentTask.approval_level === 'Level 2 Approval';

                return (
                  <Box display="flex" alignItems="center" flexWrap="wrap">
                    {/* Approval Level Chip */}
                    {/* <Chip
                      label={isLevel1 ? 'Level 1 Pending' : isLevel2 ? 'Level 2 Pending' : currentTask.approval_level || 'Unknown Level'}
                      style={{
                        backgroundColor: isLevel1 ? '#e3f2fd' : isLevel2 ? '#fff3e0' : '#f5f5f5',
                        color: isLevel1 ? '#1565c0' : isLevel2 ? '#ef6c00' : '#666',
                        fontWeight: 600,
                        fontSize: '0.85rem',
                        padding: '8px 12px',
                        height: '32px',
                        marginRight: '4px'
                      }}
                    /> */}


                    {/* Journey Type Chip */}
                    {currentTask.journey && (
                      <Chip
                        label={currentTask.journey}
                        style={{
                          backgroundColor: currentTask.journey.toLowerCase() === 'client' ? '#e8f5e8' : '#fff8e1',
                          color: currentTask.journey.toLowerCase() === 'client' ? '#2e7d2e' : '#f57c00',
                          fontWeight: 500,
                          fontSize: '0.85rem',
                          padding: '8px 12px',
                          height: '32px'
                        }}
                      />
                    )}
                  </Box>
                );
              })()}
            </Box>
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {detailsLoading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress size={60} style={{ color: '#7500C0' }} />
                <Typography className={classes.loadingText}>
                  Loading request details...
                </Typography>
              </div>
            ) : orderDetails ? (
              <Box>
                {/* Request Summary Card */}
                <div className={classes.summaryCard}>
                  <Typography className={classes.sectionTitle}>
                    Request Summary
                  </Typography>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Order ID</Typography>
                      <Typography className={classes.fieldValue}>
                        {safeGetValue(orderDetails, 'OrderUId') || safeGetValue(orderDetails, 'OrderItems.0.OrderItemUId', 'N/A')}
                      </Typography>
                    </Grid> */}
                    <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Client</Typography>
                      <Typography className={classes.fieldValue}>
                        {safeGetValue(orderDetails, 'ClientName', 'N/A')}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Platform Type</Typography>
                      <Typography className={classes.fieldValue}>
                        {getConfigValue(safeGetValue(orderDetails, 'OrderItems.0.Config'), 'AaamPlatformType')}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Requested By</Typography>
                      <Typography className={classes.fieldValue}>
                        {safeGetValue(orderDetails, 'OrderItems.0.CreatedBy', 'N/A')}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Request Date</Typography>
                      <Typography className={classes.fieldValue}>
                        {(() => {
                          try {
                            const createdDate = safeGetValue(orderDetails, 'OrderItems.0.CreatedDate');
                            if (createdDate && createdDate !== 'N/A') {
                              return new Date(createdDate).toLocaleDateString();
                            }
                            return 'N/A';
                          } catch (error) {
                            return 'N/A';
                          }
                        })()}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography className={classes.fieldLabel}>Environment</Typography>
                      <Typography className={classes.fieldValue}>
                        {getConfigValue(safeGetValue(orderDetails, 'OrderItems.0.Config'), 'Environment')}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>

                {/* Project & Financial Details */}
                <div className={classes.detailCard}>
                  <Typography className={classes.sectionTitle}>
                    Project & Financial Details
                  </Typography>
                  <Grid container spacing={2}>
                    {(() => {
                      const config = safeGetValue(orderDetails, 'OrderItems.0.Config');
                      if (!config) return null;

                      const projectFields = [
                        { key: 'ProjectName', label: 'Project Name' },
                        { key: 'TeamName', label: 'Team Name' },
                        { key: 'RITM', label: 'RITM / Opportunity ID' },
                        { key: 'WBSEcode', label: 'WBSE Code' },
                        { key: 'SAPContractID', label: 'SAP Contract ID' },
                        { key: 'EndToEndUId', label: 'End-to-End UID' }
                      ];

                      return projectFields.map((field) => {
                        const value = getConfigValue(config, field.key);
                        if (value === 'N/A') return null;
                        return (
                          <Grid item xs={6} key={field.key}>
                            <Typography className={classes.fieldLabel}>{field.label}</Typography>
                            <Typography className={classes.fieldValue}>
                              {value}
                            </Typography>
                          </Grid>
                        );
                      });
                    })()}
                  </Grid>
                </div>

                {/* Technical Configuration */}
                <div className={classes.detailCard}>
                  <Typography className={classes.sectionTitle}>
                    Technical Configuration
                  </Typography>
                  <Grid container spacing={2}>
                    {(() => {
                      const config = safeGetValue(orderDetails, 'OrderItems.0.Config');
                      if (!config) return null;

                      const techFields = [
                        { key: 'DeploymentRegion', label: 'Deployment Region' },
                        { key: 'InstanceType', label: 'Instance Type' },
                        // { key: 'Tier', label: 'Tier' },
                        { key: 'DomainContextRoot', label: 'Domain Context Root' },
                        { key: 'AdminDistributionGroup', label: 'Admin Distribution Group' },
                        { key: 'TentativeServiceEndDate', label: 'Service End Date' }
                      ];

                      return techFields.map((field) => {
                        const value = getConfigValue(config, field.key);
                        if (value === 'N/A') return null;
                        return (
                          <Grid item xs={6} key={field.key}>
                            <Typography className={classes.fieldLabel}>{field.label}</Typography>
                            <Typography className={classes.fieldValue}>
                              {field.key === 'TentativeServiceEndDate' && value !== 'N/A' ?
                                new Date(value).toLocaleDateString() : value}
                            </Typography>
                          </Grid>
                        );
                      });
                    })()}
                  </Grid>
                </div>

                {/* Request Notes */}
                <div className={classes.justificationCard}>
                  <Typography className={classes.sectionTitle}>
                    Request Notes
                  </Typography>
                  <Typography className={classes.justificationText}>
                    {getConfigValue(safeGetValue(orderDetails, 'OrderItems.0.Config'), 'RequestNotes')}
                  </Typography>
                </div>

                {/* Clarification History */}
                {(() => {
                  const config = safeGetValue(orderDetails, 'OrderItems.0.Config');
                  if (!config) return null;

                  // Get multi-round clarification history
                  const historyEntries = config.filter(item =>
                    item.Key && item.Key.startsWith('ClarificationHistory_')
                  ).map(item => {
                    try {
                      return JSON.parse(item.Value);
                    } catch (e) {
                      return null;
                    }
                  }).filter(Boolean);

                  // Sort by round and timestamp
                  historyEntries.sort((a, b) => {
                    if (a.round !== b.round) return a.round - b.round;
                    return new Date(a.timestamp) - new Date(b.timestamp);
                  });

                  // Fallback to legacy single clarification check
                  let hasClarificationData = historyEntries.length > 0;
                  if (!hasClarificationData) {
                    const clarificationComments = getConfigValue(config, 'ClarificationComments');
                    const clarificationResponse = getConfigValue(config, 'ClarificationResponse');
                    hasClarificationData = clarificationComments !== 'N/A' || clarificationResponse !== 'N/A';
                  }

                  if (!hasClarificationData) return null;

                  // Group history by rounds
                  const rounds = {};
                  historyEntries.forEach(entry => {
                    if (!rounds[entry.round]) rounds[entry.round] = [];
                    rounds[entry.round].push(entry);
                  });

                  return (
                    <div className={classes.detailCard} style={{ marginTop: '16px' }}>
                      <Typography className={classes.sectionTitle} style={{ color: '#f39c12', marginBottom: '16px' }}>
                        Clarification History
                      </Typography>

                      {/* Multi-round clarification display */}
                      {historyEntries.length > 0 ? (
                        Object.keys(rounds).map(roundNum => (
                          <div key={roundNum} style={{ marginBottom: '12px' }}>
                            {rounds[roundNum].map((entry, idx) => (
                              <div key={idx} style={{
                                backgroundColor: entry.type === 'REQUEST' ? '#fff3cd' : '#e3f2fd',
                                border: `1px solid ${entry.type === 'REQUEST' ? '#ffc107' : '#2196f3'}`,
                                borderRadius: '8px',
                                padding: '16px',
                                marginBottom: '8px',
                                marginLeft: '16px'
                              }}>
                                <Typography variant="body2" style={{ fontWeight: 'bold', color: entry.type === 'REQUEST' ? '#856404' : '#1976d2', marginBottom: '8px' }}>
                                  {entry.type === 'REQUEST' ? 'Clarification Requested' : 'Clarification Response'}
                                </Typography>
                                <Typography variant="body2" style={{ color: entry.type === 'REQUEST' ? '#856404' : '#1976d2', marginBottom: '8px' }}>
                                  <strong>{entry.type === 'REQUEST' ? 'Requested by:' : 'Responded by:'}</strong> {entry.type === 'REQUEST' ?
                                    (entry.requester ? entry.requester.split('@')[0] : 'Unknown') :
                                    (entry.respondent ? entry.respondent.split('@')[0] : 'Unknown')
                                  }
                                  <span style={{ marginLeft: '16px' }}>
                                    <strong>Date:</strong> {new Date(entry.timestamp).toLocaleString()}
                                  </span>
                                </Typography>
                                <Typography variant="body2" style={{ color: entry.type === 'REQUEST' ? '#856404' : '#1976d2', fontStyle: 'italic' }}>
                                  "{entry.type === 'REQUEST' ? entry.comments : entry.response}"
                                </Typography>
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        // Legacy single clarification display
                        <>
                          {/* Clarification Request */}
                          {(() => {
                            const clarificationComments = getConfigValue(config, 'ClarificationComments');
                            const clarificationRequester = getConfigValue(config, 'ClarificationRequester');
                            const clarificationRequestDate = getConfigValue(config, 'ClarificationRequestDate');

                            if (clarificationComments === 'N/A') return null;

                            return (
                              <div style={{
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '8px',
                                padding: '16px',
                                marginBottom: '16px'
                              }}>
                                <Typography variant="body2" style={{ fontWeight: 'bold', color: '#856404', marginBottom: '8px' }}>
                                  Clarification Requested
                                </Typography>
                                <Typography variant="body2" style={{ color: '#856404', marginBottom: '8px' }}>
                                  <strong>Requested by:</strong> {clarificationRequester !== 'N/A' ? clarificationRequester.split('@')[0] : 'Unknown'}
                                  {clarificationRequestDate !== 'N/A' && (
                                    <span style={{ marginLeft: '16px' }}>
                                      <strong>Date:</strong> {new Date(clarificationRequestDate).toLocaleString()}
                                    </span>
                                  )}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#856404', fontStyle: 'italic' }}>
                                  "{clarificationComments}"
                                </Typography>
                              </div>
                            );
                          })()}

                          {/* Clarification Response */}
                          {(() => {
                            const clarificationResponse = getConfigValue(config, 'ClarificationResponse');
                            const clarificationRespondent = getConfigValue(config, 'ClarificationRespondent');
                            const clarificationResponseDate = getConfigValue(config, 'ClarificationResponseDate');

                            if (clarificationResponse === 'N/A') return null;

                            return (
                              <div style={{
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #2196f3',
                                borderRadius: '8px',
                                padding: '16px'
                              }}>
                                <Typography variant="body2" style={{ fontWeight: 'bold', color: '#1976d2', marginBottom: '8px' }}>
                                  Clarification Response
                                </Typography>
                                <Typography variant="body2" style={{ color: '#1976d2', marginBottom: '8px' }}>
                                  <strong>Responded by:</strong> {clarificationRespondent !== 'N/A' ? clarificationRespondent.split('@')[0] : 'Unknown'}
                                  {clarificationResponseDate !== 'N/A' && (
                                    <span style={{ marginLeft: '16px' }}>
                                      <strong>Date:</strong> {new Date(clarificationResponseDate).toLocaleString()}
                                    </span>
                                  )}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#1976d2', fontStyle: 'italic' }}>
                                  "{clarificationResponse}"
                                </Typography>
                              </div>
                            );
                          })()}
                        </>
                      )}
                    </div>
                  );
                })()}

              </Box>
            ) : (
              <Typography color="error">Failed to load request details</Typography>
            )}
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={() => setDetailsDialog(false)}
              disabled={actionLoading}
              className={`${classes.dialogButton} ${classes.cancelButton}`}
              variant="outlined"
            >
              Cancel
            </Button>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px' }}>
              <Button
                onClick={handleClarificationClick}
                className={`${classes.dialogButton} ${classes.clarificationButton}`}
                variant="contained"
                disabled={actionLoading}
                startIcon={<HelpIcon />}
              >
                Request Clarification
              </Button>
              <Button
                onClick={handleRejectClick}
                className={`${classes.dialogButton} ${classes.rejectButton}`}
                variant="contained"
                disabled={actionLoading}
                startIcon={<CancelIcon />}
              >
                Reject Request
              </Button>
              <Button
                onClick={handleApproveClick}
                className={`${classes.dialogButton} ${classes.approveButton}`}
                variant="contained"
                disabled={actionLoading}
                startIcon={<CheckCircleIcon />}
              >
                Approve Request
              </Button>
            </div>
          </DialogActions>
        </Dialog>

        {/* Confirmation Dialog */}
        <Dialog
          open={confirmDialog}
          onClose={handleCancelConfirm}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            className: classes.dialogPaper
          }}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleText}>
              Confirm {confirmAction === 'approve' ? 'Approval' : 'Rejection'}
            </Typography>
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {isL2ApprovalLoading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress size={60} style={{ color: '#7500C0' }} />
                <Typography className={classes.loadingText}>
                  {confirmAction === 'approve' ? 'Approving' : 'Rejecting'} request...
                </Typography>
              </div>
            ) : (
              <>
                <Typography variant="body1" style={{
                  marginBottom: '16px',
                  color: '#495057',
                  fontSize: '16px',
                  fontWeight: 500
                }}>
                  Are you sure you want to {confirmAction} request <strong style={{ color: '#7500C0' }}>{selectedRequest}</strong>?
                </Typography>

                <TextField
                  label={`Comments for ${confirmAction}`}
                  multiline
                  rows={3}
                  variant="outlined"
                  value={confirmComments}
                  onChange={(e) => setConfirmComments(e.target.value)}
                  fullWidth
                  required
                  placeholder={`Please provide your reason for ${confirmAction}ing this request...`}
                  className={classes.commentField}
                  error={!confirmComments.trim() && confirmComments !== ''}
                  style={{ marginBottom: '20px' }}
                />

                {/* Review Requirement Decision - For L1 Approvers Only */}
                {/* {confirmAction === 'approve' && (() => {
                  const currentTask = tasks.find(task => task.request_id === selectedRequest);
                  const isL1Approval = currentTask && currentTask.approval_level === 'Level 1 Approval';

                  // Determine if this is a client or internal order
                  const isClientOrder = currentTask && currentTask.journey && currentTask.journey.toLowerCase() === 'client';
                  const reviewTeam = isClientOrder ? 'Security Operations (SecOps)' : 'Platform Operations (Platform Ops)';
                  const reviewTeamShort = isClientOrder ? 'SecOps' : 'Platform Ops';

                  if (!isL1Approval) return null;

                  return (
                    <Box style={{
                      marginBottom: '20px',
                      padding: '16px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '6px',
                      border: '1px solid #e9ecef',
                      boxShadow: '0 2px 8px rgba(117, 0, 192, 0.08)'
                    }}>
                      <Typography variant="subtitle1" style={{
                        fontWeight: 600,
                        color: '#7500C0',
                        fontSize: '16px',
                        marginBottom: '12px'
                      }}>
                        {reviewTeam} Review Decision
                      </Typography>

                      <Box style={{
                        backgroundColor: '#ffffff',
                        border: level2Required ? '2px solid #7500C0' : '2px solid #48bb78',
                        borderRadius: '8px',
                        padding: '16px',
                        transition: 'all 0.3s ease'
                      }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={level2Required}
                              onChange={(e) => setLevel2Required(e.target.checked)}
                              style={{ color: '#7500C0', padding: '9px' }}
                            />
                          }
                          label={
                            <Typography variant="body2" style={{
                              color: '#495057',
                              lineHeight: '1.6',
                              fontSize: '14px',
                              fontWeight: 500,
                              paddingTop: '9px',
                              paddingBottom: '9px'
                            }}>
                              This request requires {reviewTeam} team review before provisioning
                            </Typography>
                          }
                          style={{ alignItems: 'center', margin: 0, width: '100%' }}
                        />

                        <Box style={{
                          marginTop: '12px',
                          padding: '12px',
                          backgroundColor: level2Required ? '#e6f3ff' : '#e8f5e8',
                          borderRadius: '6px',
                          borderLeft: `4px solid ${level2Required ? '#7500C0' : '#48bb78'}`
                        }}>
                          <Typography variant="body2" style={{
                            color: level2Required ? '#5a0090' : '#2d5a2d',
                            fontSize: '13px',
                            fontWeight: 500,
                            lineHeight: '1.5'
                          }}>
                            {level2Required
                              ? `Request will proceed to ${reviewTeam} team review after your approval`
                              : `Request will be provisioned immediately after your approval (bypassing ${reviewTeamShort} review)`}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })()} */}

                {/* Approval Acknowledgement Section */}
                {confirmAction === 'approve' && (
                  <Box style={{
                    padding: '16px',
                    borderRadius: '6px',
                    border: '1px solid #e5e7eb',
                    backgroundColor: 'rgba(0, 0, 0, 0.02)'
                  }}>
                    <Typography variant="subtitle2" style={{
                      fontWeight: 700,
                      color: '#1a202c',
                      fontSize: '15px',
                      marginBottom: '16px'
                    }}>
                      Approval Acknowledgement <span style={{ color: '#6b7280' }}>*</span>
                    </Typography>

                    {/* Loading State */}
                    {acknowledgementLoading && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '40px',
                        color: '#6c757d'
                      }}>
                        <CircularProgress size={24} style={{ marginRight: '12px', color: '#7500C0' }} />
                        <span style={{ fontSize: '14px' }}>Loading acknowledgement...</span>
                      </div>
                    )}

                    {/* Error State */}
                    {acknowledgementError && !acknowledgementLoading && (
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#fee2e2',
                        border: '1px solid #fca5a5',
                        borderRadius: '6px',
                        marginBottom: '16px'
                      }}>
                        <Typography variant="body2" style={{
                          color: '#dc2626',
                          fontSize: '14px',
                          fontWeight: '500'
                        }}>
                          {acknowledgementError}
                        </Typography>
                      </div>
                    )}

                    {/* Acknowledgement Content */}
                    {acknowledgementData && !acknowledgementLoading && (
                      <>
                        <div style={{
                          backgroundColor: 'transparent',
                          padding: '0 0 16px 0',
                          marginBottom: '16px',
                          borderBottom: '1px solid #e5e7eb'
                        }}>
                          <div style={{
                            color: '#6b7280',
                            lineHeight: '1.7',
                            fontSize: '14px',
                            fontWeight: '400'
                          }}>
                            {formatAcknowledgementText(acknowledgementData.message)}
                          </div>
                        </div>

                        {/* Acknowledgement Checkbox */}
                        <FormControlLabel
                          style={{
                            marginLeft: '10px',
                            alignItems: 'center',
                            margin: 0,
                            display: 'flex'
                          }}
                          control={
                            <Checkbox
                              checked={acknowledgementChecked}
                              onChange={(e) => setAcknowledgementChecked(e.target.checked)}
                              style={{ color: '#7500C0', padding: '6px' }}
                            />
                          }
                          label={
                            <Typography variant="body2" style={{
                              fontSize: '14px',
                              fontWeight: 500,
                              color: '#495057'
                            }}>
                              I accept and agree to the terms stated above.
                            </Typography>
                          }
                        />

                        {!acknowledgementChecked && (
                          <Box style={{
                            marginTop: '8px',
                            padding: '8px 12px',
                            backgroundColor: '#ffe6e6',
                            borderRadius: '4px',
                            border: '1px solid #ffcccc'
                          }}>
                            <Typography variant="caption" style={{
                              color: '#cc0000',
                              fontSize: '12px',
                              fontWeight: 500
                            }}>
                              Required: Please acknowledge the terms before approving
                            </Typography>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                )}
              </>
            )}
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={handleCancelConfirm}
              className={`${classes.dialogButton} ${classes.cancelButton}`}
              variant="outlined"
              disabled={isL2ApprovalLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              className={`${classes.dialogButton} ${confirmAction === 'approve' ? classes.approveButton : classes.rejectButton}`}
              variant="contained"
              disabled={isL2ApprovalLoading || (confirmAction === 'approve' && !acknowledgementChecked)}
              startIcon={isL2ApprovalLoading ? <CircularProgress size={18} color="inherit" /> : null}
            >
              {isL2ApprovalLoading ? 'Processing...' : `Confirm ${confirmAction === 'approve' ? 'Approval' : 'Rejection'}`}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Request Clarification Dialog */}
        <Dialog
          open={clarificationDialog}
          onClose={handleCancelClarification}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            className: classes.dialogPaper
          }}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleText}>
              Request Clarification
            </Typography>
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {isL2ApprovalLoading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress size={60} style={{ color: '#7500C0' }} />
                <Typography className={classes.loadingText}>
                  Sending clarification request...
                </Typography>
              </div>
            ) : (
              <>
                <Typography variant="body1" style={{ marginBottom: '16px', color: '#495057' }}>
                  What clarifications do you need from the requestor for request <strong>{selectedRequest}</strong>?
                </Typography>

                {/* Show previous clarification history if exists */}
                {(() => {
                  if (!orderDetails) return null;

                  const config = safeGetValue(orderDetails, 'OrderItems.0.Config');
                  if (!config) return null;

                  // Get latest clarification from history or fallback to legacy fields
                  let latestClarificationComments = getConfigValue(config, 'ClarificationComments');
                  let latestClarificationResponse = getConfigValue(config, 'ClarificationResponse');

                  // Try to get latest from history if available
                  const historyEntries = [];
                  config.forEach(item => {
                    if (item.Key && item.Key.startsWith('ClarificationHistory_')) {
                      try {
                        const data = JSON.parse(item.Value);
                        historyEntries.push(data);
                      } catch (e) {
                        // Ignore parsing errors
                      }
                    }
                  });

                  if (historyEntries.length > 0) {
                    // Sort by round and timestamp to get latest
                    historyEntries.sort((a, b) => {
                      if (b.round !== a.round) return b.round - a.round;
                      return new Date(b.timestamp) - new Date(a.timestamp);
                    });

                    // Get latest request and response
                    const latestRequest = historyEntries.find(e => e.type === 'REQUEST');
                    const latestResponse = historyEntries.find(e => e.type === 'RESPONSE');

                    if (latestRequest) {
                      latestClarificationComments = latestRequest.comments || latestClarificationComments;
                    }
                    if (latestResponse) {
                      latestClarificationResponse = latestResponse.response || latestClarificationResponse;
                    }
                  }

                  const prevClarificationComments = latestClarificationComments;
                  const prevClarificationResponse = latestClarificationResponse;

                  if (prevClarificationComments === 'N/A' && prevClarificationResponse === 'N/A') return null;

                  return (
                    <div style={{ marginBottom: '16px' }}>
                      <Typography variant="body2" style={{ fontWeight: 'bold', color: '#f39c12', marginBottom: '8px' }}>
                        Latest Clarification Exchange:
                      </Typography>

                      {prevClarificationComments !== 'N/A' && (
                        <div style={{
                          backgroundColor: '#fff3cd',
                          border: '1px solid #ffc107',
                          borderRadius: '4px',
                          padding: '8px',
                          marginBottom: '8px'
                        }}>
                          <Typography variant="caption" style={{ fontWeight: 'bold', color: '#856404' }}>
                            Previously Asked:
                          </Typography>
                          <Typography variant="body2" style={{ fontSize: '12px', color: '#856404' }}>
                            "{prevClarificationComments}"
                          </Typography>
                        </div>
                      )}

                      {prevClarificationResponse !== 'N/A' && (
                        <div style={{
                          backgroundColor: '#e3f2fd',
                          border: '1px solid #2196f3',
                          borderRadius: '4px',
                          padding: '8px',
                          marginBottom: '8px'
                        }}>
                          <Typography variant="caption" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                            Response Received:
                          </Typography>
                          <Typography variant="body2" style={{ fontSize: '12px', color: '#1976d2' }}>
                            "{prevClarificationResponse}"
                          </Typography>
                        </div>
                      )}
                    </div>
                  );
                })()}

                <TextField
                  label="Additional Clarification Details"
                  multiline
                  rows={4}
                  variant="outlined"
                  value={clarificationComments}
                  onChange={(e) => setClarificationComments(e.target.value)}
                  fullWidth
                  required
                  placeholder="Please describe what additional information or clarification is needed from the requestor..."
                  className={classes.commentField}
                  error={!clarificationComments.trim() && clarificationComments !== ''}
                />
              </>
            )}
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={handleCancelClarification}
              className={`${classes.dialogButton} ${classes.cancelButton}`}
              variant="outlined"
              disabled={isL2ApprovalLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmClarification}
              className={`${classes.dialogButton} ${classes.clarificationButton}`}
              variant="contained"
              disabled={isL2ApprovalLoading}
              startIcon={isL2ApprovalLoading ? <CircularProgress size={18} color="inherit" /> : <HelpIcon />}
            >
              {isL2ApprovalLoading ? 'Processing...' : 'Send Clarification Request'}
            </Button>
          </DialogActions>
        </Dialog>

        <ToastContainer position="top-right" />
      </div>
      <div className={classes.fixedFooter}>
        <Footer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    email: state.home.email || state.auth.userDetails,
    isAuthenticated: state.auth.isAuthenticated,
    isL2ApprovalLoading: state.fui.isSubmitFormLoading,
    isL2ApprovalSuccess: state.fui.isL2ApprovalSuccess,
    isFormSubmittedSuccessful: state.fui.isFormSubmittedSuccessful,
    l2ApprovalError: state.fui.l2ApprovalError,
  };
};

const mapDispatchToProps = {
  processL2Approval,
  processStandardApproval,
  processRequestClarification,
  resetL2ApprovalState,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Approvals));